import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gax-page-section-header-bottom-bar',
  templateUrl: './page-section-header-bottom-bar.component.html',
  styleUrl: './page-section-header-bottom-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageSectionHeaderBottomBarComponent {}
